import { add } from '../../customers/services/CustomersService';
import { generatePersonName, generateCompanyName } from './nameGenerators';

const generatePersonData = () => {
  const name = generatePersonName();
  return {
    name,
    description: `Individual customer - ${name}`,
    status: 'Active'
  };
};

const generateCompanyData = () => {
  const name = generateCompanyName();
  return {
    name,
    description: `Business customer - ${name}`,
    status: 'Active'
  };
};

const generateCustomerData = () => {
  // 60% chance for person, 40% chance for company
  return Math.random() < 0.6 ? generatePersonData() : generateCompanyData();
};

export const generateCustomersTestData = async (count: number) => {
  const promises = [];
  
  for (let i = 1; i <= count; i++) {
    const customerData = generateCustomerData();
    promises.push(add(customerData));
  }
  
  try {
    const results = await Promise.all(promises);
    console.log(`Generated ${count} test customers`);
    return results.filter(Boolean);
  } catch (error) {
    console.error('Error generating customer test data:', error);
    return [];
  }
};